import { render } from "./CollectionDetailsModal.vue.js?vue&type=template&id=520e6717!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionDetailsModal.vue?vue&type=template&id=520e6717"
import script from "./CollectionDetailsModal.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionDetailsModal.vue?vue&type=script&lang=js"
export * from "./CollectionDetailsModal.vue.js?vue&type=script&lang=js!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/CollectionDetailsModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "520e6717"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('520e6717', __exports__)) {
    api.reload('520e6717', __exports__)
  }
  
  module.hot.accept("./CollectionDetailsModal.vue.js?vue&type=template&id=520e6717!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionDetailsModal.vue?vue&type=template&id=520e6717", () => {
    api.rerender('520e6717', render)
  })

}


export default __exports__